'use client';

import RichText from '@/components/blocks/RichText';
import Hero from '@/components/blocks/Hero';
import Gallery from '@/components/blocks/Gallery';
import PhotoCollage from '@/components/blocks/PhotoCollage';
import Pricing from '@/components/blocks/Pricing';
import Posts from '@/components/blocks/Posts';
import Form from '@/components/blocks/Form';
import TrustIndicators from '@/components/blocks/TrustIndicators';
import Testimonials from '@/components/blocks/Testimonials';
import Partners from '@/components/blocks/Partners';
import ServiceArea from '@/components/blocks/ServiceArea';
import Services from '@/components/blocks/Services';
import QuoteFormBlock from '@/components/blocks/QuoteFormBlock';
import BusinessQuoteFormBlock from '@/components/blocks/BusinessQuoteFormBlock';
import ContactFormBlock from '@/components/blocks/ContactFormBlock';
import Faq from '@/components/blocks/Faq';

import ContentImage from '@/components/blocks/ContentImage';

import MultiColumn from '@/components/blocks/MultiColumn';
import SimpleHero from '@/components/blocks/SimpleHero';
import ProjectShowcase from '@/components/blocks/ProjectShowcase';
import FeaturedLinks from '@/components/blocks/FeaturedLinks';

interface BaseBlockProps {
	block: {
		collection: string;
		item: any;
		id: string;
	};
	pageId?: string;
	collection?: string;
}

const BaseBlock = ({ block, pageId, collection }: BaseBlockProps) => {
	const components: Record<string, React.ElementType> = {
		block_hero: Hero,
		block_content_image: ContentImage,
		block_richtext: RichText,
		block_gallery: Gallery,
		block_photo_collage: PhotoCollage,
		block_pricing: Pricing,
		block_posts: Posts,
		block_form: Form,
		block_trust_indicators: TrustIndicators,
		block_testimonials: Testimonials,
		block_partners: Partners,
		block_servicearea: ServiceArea,
		block_services: Services,
		block_quote_form: QuoteFormBlock,
		block_business_quote_form: BusinessQuoteFormBlock,
		block_contact_form: ContactFormBlock,
		block_faq: Faq,
		block_multicolumn: MultiColumn,
		block_simple_hero: SimpleHero,
		block_project_showcase: ProjectShowcase,
		block_featuredlinks: FeaturedLinks,
	};

	const Component = components[block.collection];

	if (!Component) {
		return null;
	}
	const itemId = block.item?.id;

	return <Component data={block.item} blockId={block.id} itemId={itemId} />;
};

export default BaseBlock;
